 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCH00_HALFTITLE from '@/components/xhtml/ch00_halftitle'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH00A_TITLE from '@/components/xhtml/ch00a_title'
 import XHTMLCH01_DEDICATION from '@/components/xhtml/ch01_dedication'
 import XHTMLCH02_ACK from '@/components/xhtml/ch02_ack'
 import XHTMLCH03_TOC from '@/components/xhtml/ch03_toc'
 import XHTMLCH04_INTROD from '@/components/xhtml/ch04_introd'
 import XHTMLCH05_INGREDIENTS from '@/components/xhtml/ch05_ingredients'
 import XHTMLCH06_EQUIPMENT from '@/components/xhtml/ch06_equipment'
 import XHTMLCH07_CHAPTER1 from '@/components/xhtml/ch07_chapter1'
 import XHTMLCH08_CHAPTER2 from '@/components/xhtml/ch08_chapter2'
 import XHTMLCH09_CHAPTER3 from '@/components/xhtml/ch09_chapter3'
 import XHTMLCH10_CHAPTER4 from '@/components/xhtml/ch10_chapter4'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCH11_INDEX from '@/components/xhtml/ch11_index'
 import XHTMLCH12_SOURCES from '@/components/xhtml/ch12_sources'
 import XHTMLCH13_TABLE from '@/components/xhtml/ch13_table'
 import XHTMLCH14_COPY from '@/components/xhtml/ch14_copy'
 import XHTML100CHRONICLE_EBOOKS from '@/components/xhtml/100-chronicle_ebooks'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/ch00_halftitle",
 			"name" : "xhtml/ch00_halftitle",
 			"component" : XHTMLCH00_HALFTITLE
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/ch00a_title",
 			"name" : "xhtml/ch00a_title",
 			"component" : XHTMLCH00A_TITLE
 		},
 		{
 			"path" : "/xhtml/ch01_dedication",
 			"name" : "xhtml/ch01_dedication",
 			"component" : XHTMLCH01_DEDICATION
 		},
 		{
 			"path" : "/xhtml/ch02_ack",
 			"name" : "xhtml/ch02_ack",
 			"component" : XHTMLCH02_ACK
 		},
 		{
 			"path" : "/xhtml/ch03_toc",
 			"name" : "xhtml/ch03_toc",
 			"component" : XHTMLCH03_TOC
 		},
 		{
 			"path" : "/xhtml/ch04_introd",
 			"name" : "xhtml/ch04_introd",
 			"component" : XHTMLCH04_INTROD
 		},
 		{
 			"path" : "/xhtml/ch05_ingredients",
 			"name" : "xhtml/ch05_ingredients",
 			"component" : XHTMLCH05_INGREDIENTS
 		},
 		{
 			"path" : "/xhtml/ch06_equipment",
 			"name" : "xhtml/ch06_equipment",
 			"component" : XHTMLCH06_EQUIPMENT
 		},
 		{
 			"path" : "/xhtml/ch07_chapter1",
 			"name" : "xhtml/ch07_chapter1",
 			"component" : XHTMLCH07_CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js